import { Directive } from '@angular/core';

@Directive({
  selector: '[appDisableForm]'
})
export class DisableFormDirective {

  constructor() { }

}
